# Fun Facts About Platypus
## 2023/11/29

Did you know that there's an animal that is missing a major organ? I'll tell you more!

![Alt Platypus alt ><](https://media.giphy.com/media/iPgo1ADaEkrP8Dr1BS/giphy-downsized.gif)

### 1. People didn't believe platypus was real

English captain John Hunter first wrote about the platypuses in 1797 with some sketches & a specimen. Nobody believed it was real.

![Platypus 1 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/platypus1.png?raw=true)

### 2. Its bill is goddamn powerful

What appears to be a beak is actually part of its skull. Apparently it's quite soft in the middle.

This bill is not just aesthetically cute; it's incredibly powerful. It allows platypuses to detect underwater prey using electrical impulses (a.k.a electroreception) to locate objects in the deepest and darkest of waters. It works so well that platypuses can hunt with their eyes, ears, and nose all closed, relying entirely on the bill’s electrolocation.

![Platypus 2 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/platypus2.png?raw=true)

### 3. But they don't have teeth
They don't have teeth, they must scoop up bits of gravel with its food to help “chew” its meal. XD

### 4. They don't have stomachs
It's unclear why they lack a stomach, but indeed, platypuses are one of the two mammals that don't have a stomach. (The other is the echidna!) Perhaps their diet makes a stomach unnecessary.

### 5. They don't have nipples either
As egg-laying mammals, platypuses have a unique method for nursing their babies. They don't have nipples, instead they "sweat" milk through specialized glands in the skin. 

Because of this strange feeding system, platypuses have developed milk with highly antibacterial properties and extremely high iron content. Scientists are trying to solve the global superbug threat with platypuses' milk. Go platypuses!

### 6. They're venomous too
Male platypuses have spurs that are connected to a venom gland. It is lethal enough to kill a medium-sized dog but not humans (though it's still excruciatingly painful & there is no antivenom so be careful). The venom is more potent during the breeding season, leading scientists to believe that it is used to defend mates and resources from rival males.

![platypus venom alt ><](https://upload.wikimedia.org/wikipedia/commons/3/3d/Platypus_spur.JPG)

### 7. They can drown pretty easily
Even though they're a badass animal, they can drown pretty easily. Normally, a platypus stays underwater for between 1 and 2 minutes. So "Opera house” nets that people set to catch crayfish and yabbies can be death traps for platypuses. BE CAREFUL!
![Platypus 3 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/platypus3.png?raw=true)

### 8. They are biofluorescent
Under UV light, they all glow. Scientists think it's probably because they're nocturnals so being biofluorescent help them see & communicate each other.

![platypus biofluorescent alt ><](https://cdn.mos.cms.futurecdn.net/J29hZbBGEePokbrTdRYCEi.jpg)

### 9. Last but not least, they maintain a stable body heat
Despite the fact that platypuses live in one area of the world, they experience a very extreme climate; from rainforests to the chilly mountainous regions of Tasmania and the Australian Alps. However, that's not a problem because its fur is waterproof and traps an insulating layer of air to keep its body temperature stable, even in cold water for hours.

![platypus scratching alt ><](https://media.giphy.com/media/kyuhMhJnpGnz9C7TT4/giphy-downsized.gif)

Isn't it incredible that there is a semi-aquatic, egg-laying, venomous, electrolocating, milk-sweating, biofluorescent, stomachless, teethless, temperature-controlled animal? And they just so happen to be adorable!

**References**
- [Washington Post](washingtonpost.com/news/speaking-of-science/wp/2015/04/01/the-platypus-is-so-weird-that-scientists-thought-the-first-specimen-was-a-hoax)
- [Reed college](https://www.reed.edu/biology/professors/srenn/pages/teaching/web_2007/myp_site/)
- [San Diego zoo](https://animals.sandiegozoo.org/animals/platypus)
- [New Atlas](https://newatlas.com/platypus-milk-antimicrobial-protein-csiro-deakin/53809/)
- [Guardian](https://www.theguardian.com/science/2020/dec/19/tasmanian-devils-glow-in-the-dark-australian-animals-glowing-platypus-wombat-echidna-bandicoot-scientists-investigate-australia-marsupials-light)